import { CSSProperties } from 'react';
import StyledWrapper from './style';

interface ItemPageTitleProps {
	text?: string;
	removeGrayLine?: boolean;
	isUnsaved?: boolean;
	style?: CSSProperties;
}

const ItemPageTitle = ({ text, removeGrayLine, isUnsaved, style }: ItemPageTitleProps) => (
	<StyledWrapper.Container style={style}>
		{text ? (
			<>
				{!removeGrayLine && <StyledWrapper.GrayLine data-testid={'itemPageTitle-grayline'} />}
				<StyledWrapper.TitleText data-testid={'itemPageTitle-text'}>{text}</StyledWrapper.TitleText>
				{isUnsaved && (
					<>
						{' / '}
						<StyledWrapper.UnsavedText>unsaved</StyledWrapper.UnsavedText>
					</>
				)}
				{!removeGrayLine && <StyledWrapper.GrayLine data-testid={'itemPageTitle-grayline'} />}
			</>
		) : (
			<>{!removeGrayLine && <StyledWrapper.GrayLine data-testid={'itemPageTitle-grayline'} />}</>
		)}
	</StyledWrapper.Container>
);

export default ItemPageTitle;
